// eslint-disable-next-line
export enum ETailwindBreakpoint {
  'sm' = 'sm',
  'md' = 'md',
  'lg' = 'lg',
  'xl' = 'xl',
  '2xl' = '2xl',
}
